import { InjectionToken } from '@angular/core';
import { ObservableResult } from '../../models/result.model';
import {
  AvailableForConnect, ContactCompany,
  ContactMethod, ContactsHistory,
  ContactsMainModel,
  ContactsModel,
  ContactType, IHealthCheck, ILogOut, RelatedLeadsHistory
} from '../../models/contacts/contacts.model';

/** Injection token for the data service */
export const CONTACTS_DATA_SERVICE = new InjectionToken<ContactsDataService>('[Contacts] ContactsDataService');

export interface ContactsDataService {

  getContactTypes(): ObservableResult<ContactType[]>;

  getContactMethods(): ObservableResult<ContactMethod[]>;

  getContacts(id: number): ObservableResult<ContactsModel>;

  editContact(contact: ContactsMainModel): ObservableResult<any>;

  getContactsByEmail(email: string): ObservableResult<ContactsModel>;

  getAvailableForConnect(leadId: number, search?: string): ObservableResult<AvailableForConnect[]>;

  connectContact(contactId: number, leadId?: number): ObservableResult<void>;

  connectNewContact(leadId: number, contact: ContactsMainModel): ObservableResult<void>;

  disconnectContact(contactId: number, leadId?: number): ObservableResult<void>;

  healthCheck(): ObservableResult<IHealthCheck>;

  logOut(token: string): ObservableResult<ILogOut>;

  getContactHistory(id: number): ObservableResult<ContactsHistory[]>;

  getRelatedLeads(id: number): ObservableResult<RelatedLeadsHistory[]>;

  getContactCompanies(searchTerm?: string): ObservableResult<ContactCompany[]>;
}
